export const Lista_Permisos = [
    'Equipo',
    'Reservas',
    'Productos',
    'Prestamos',
    'Inventario',
    'Operaciones',
] as const;